module.exports = __webpack_public_path__ + "img/47ne.2cb98104.svg";